import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from '../i18n/TranslationProvider'

const PageNotFound = () => {
  const { t } = useTranslation()
  return (
    <div>
      {t('common.notFound.before')} <Link to="/">{t('common.notFound.link')}</Link> {t('common.notFound.after')}
    </div>
  )
}

export default PageNotFound